import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LandingPage from '../templates/landingpage/LandingPage';
import AboutUs from '../templates/about/AboutUs';
import ContactPage from '../templates/about/components/ContactPage';
import MasBuga from '../templates/MasCampus/MasBuga';
import MasCentro from '../templates/MasCampus/MasCentro';
import MasCuautla from '../templates/MasCampus/MasCuautla';
import MasCoyoacan from '../templates/MasCampus/MasCoyoacan';

const AppRouter = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/bugambilias" element={<MasBuga />} />
        <Route path="/coyoacan" element={<MasCoyoacan />} />
        <Route path="/centro" element={<MasCentro />} />
        <Route path="/cuautla" element={<MasCuautla />} />
      </Routes>
    </Router>
  );
};

export default AppRouter;
